import { isDevelopment, isLocal, isStaging } from '@/utils/environment';
import { isLoginIdKokopelli, isSystemAdmin } from '@/utils/user';

export const canCompanyBulkCreate = (): boolean => {
  return ((isDevelopment() || isLocal() || isStaging()) &&
  isSystemAdmin() && isLoginIdKokopelli());
};
